import * as jQuery from 'jquery';
import * as _ from 'underscore';
import * as moment from 'moment';

import {
	AfterContentInit,
	ChangeDetectorRef,
	Component,
	HostListener,
	Input,
	OnDestroy,
	OnInit,
	ViewChild
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NguCarousel, NguCarouselConfig } from '@ngu/carousel';

import { ColorConfig } from '../../../analytics-core/interfaces/widget.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { ModalService } from '../../../shared/directives/modal/modal.service';
import { DisplayCreativeV3Component } from '../display-creative-v3/display-creative-v3.component';
import { BooleanLiteral } from 'typescript';
import { PATHS } from '../../../analytics/constants/analytics.constants';
@Component({
	selector: 'app-geofence-creative-r4',
	styleUrls: ['./geofence-creative-r4.component.css'],
	templateUrl: './geofence-creative-r4.component.html'
})
export class GeofenceCreativeR4Component
	extends DisplayCreativeV3Component
	implements OnInit, AfterContentInit, OnDestroy
{
	@ViewChild('carousel') carousel: NguCarousel<any>;
	@Input() downloadconfig: any;
	@Input() downloadcsvcolumns: any;
	@Input() sectionclass: string;
	@Input() showalldatesdata: boolean;
	public downloadConfiguration: any;
	public svgHeight = 500;
	public selectedLegendName;
	public activeSlide = 0;
	public customLegendData: any;
	public carouselOne: NguCarouselConfig;
	public downloadCSVColumns: any;
	public findRVersion: string;
	public isSocial: boolean;

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected modalService: ModalService,
		protected cdr: ChangeDetectorRef,
		protected sanitizer: DomSanitizer
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel, modalService, cdr, sanitizer);
		this.carouselOne = {
			grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
			loop: false,
			point: {
				visible: false
			},
			slide: 1,
			speed: 600,
			touch: true
		};
	}

	ngOnInit(): void {
		this.selectedLegendName = 'Impressions';
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.downloadCSVColumns = JSON.parse(decodeURI(this.downloadcsvcolumns));
		this.includeEngagements = true;
		this.showalldatesdata = this.showalldatesdata.toString() === 'true' ? true : false;
		this.isSocial = this.analyticsDataModel.getCurrentPath() === PATHS.SOCIAL;
		this.findRVersion = this.analyticsDataModel.config.version;
		super.ngOnInit();
	}

	ngOnDestroy(): void {
		super.ngOnDestroy();
	}

	onmoveFn(event: any): void {
		this.activeSlide = event.currentSlide;
	}

	ngAfterContentInit(): void {
		this.svgWidth = jQuery(this.bubbleChartContainer.nativeElement).width() - 40;
		this.svgHeight = jQuery(this.bubbleChartContainer.nativeElement).height() - 20;
	}

	@HostListener('window:resize', ['$event'])
	onResize(event: any): void {
		this.svgWidth = jQuery(this.bubbleChartContainer.nativeElement).width() - 40;
		this.svgHeight = jQuery(this.bubbleChartContainer.nativeElement).height() - 20;
	}

	processResponseData(responseData: any): void {
		this.graphSeriesData = [];
		if (responseData.length > 0) {
			this.hasData = true;

			this.creatives = this.mapResponseDataToInterface(responseData);
			if (this.removeKeysData.length > 0) {
				this.creatives = this.creatives.map((creative) => {
					for (const key of this.removeKeysData) {
						creative[key] = '';
					}
					return creative;
				});
			}
			const videoCreatives = _.where(this.creatives, { isVideoCreative: true });
			this.isVideoCreative = videoCreatives.length > 0;
			const selectedLegend: any = _.findWhere(this.legend, { selected: true });
			this.selectedLegend = selectedLegend;
			this.graphData = this.generateGraphDataBySelection(selectedLegend.value);
			this.graphData.categories = this.graphData.categories.map((item) => {
				return moment(item).format('MM/DD/YYYY');
			});
			this.processGraphDataForSeries();
			this.hasGraphData = true;
		} else {
			this.hasData = false;
		}
	}

	processSelectedLegendItem(legendItem: any): void {
		this.selectedLegendName = legendItem;
		this.showLoad = true;
		this.graphSeriesData = [];
		_.each(this.legend, (legend, index) => {
			if (legend['value'] === legendItem) {
				this.legend[index].selected = true;
			} else {
				this.legend[index].selected = false;
			}
		});
		this.graphData = this.generateGraphDataBySelection(legendItem);
		this.processGraphDataForSeries();
	}

	processGraphDataForSeries(): void {
		for (const series of this.graphData.series) {
			this.graphSeriesData.push({
				categories: this.graphData.categories,
				series: [series]
			});
		}
		this.customLegendData = this.buildCustomLegendArray(this.graphData.series);
		this.showLoad = false;
	}

	buildCustomLegendArray(data: any): any[] {
		const legendObjArray = [];
		for (let i = 0; i < data.length; i++) {
			const tempObj: any = {};
			tempObj.name = data[i].name;
			tempObj.color = data[i].color;
			tempObj.index = i;
			tempObj.active = true;
			legendObjArray.push(tempObj);
		}
		return legendObjArray;
	}

	downloadCSV(): void {
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey,
			this.downloadConfiguration.downloadFileName,
			this.downloadCSVColumns
		);
	}

	protected getColorFromColorConfig(index: number, opacity?: number): string {
		const availableColorsLength = _.values(this.colorsconfig).length;
		const colorIndex = index % availableColorsLength;
		const colorConfig: ColorConfig = this.colorsconfig[colorIndex];
		const fillOpacity = opacity ? opacity : colorConfig.opacity;
		let rgb = '';
		if (colorConfig.isHex) {
			rgb = this.colorUtilityService.getRGBByOpacity(colorConfig.color, fillOpacity);
		} else {
			rgb = this.colorUtilityService.getRGBByColorType(this.colorPalette, colorConfig.color, fillOpacity);
		}
		return rgb;
	}

	getPercentage(percentage) {
		return { width: `${Math.floor(percentage)}%` };
	}
}
